import { GoogleTagManagerSetting } from 'backend';
import { getGtmDataLayerName, insertDataLayers } from '../models';

type ExecuteGtmPayload = Pick<
  GoogleTagManagerSetting,
  'containerId' | 'dataLayers'
>;

export const executeGtm = ({
  containerId,
  dataLayers,
}: ExecuteGtmPayload): void => {
  const dataLayerName = getGtmDataLayerName(containerId);
  insertDataLayers(dataLayerName, dataLayers);
};
